import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-boton-secundario',
  templateUrl: './boton-secundario.component.html',
  styleUrls: ['./boton-secundario.component.scss']
})

export class BotonSecundarioComponent {
  @Input("boton_texto") boton_texto: string;
  @Input("estado") estado: string;
  @Output("boton_funcion") boton_funcion: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {

  }

  ejecutarFuncion() {
    this.boton_funcion.emit();
  }
}
